import { YearSeasonsEnum } from "@models/LTOChart";

export type LaunchesGrouping = "season" | "month";

export const LAUNCHES_GROUPING_STORAGE_KEY = "category-profile-launches-grouping";
export const LAUNCHES_SEASON_STORAGE_KEY = "category-profile-launches-season";
export const LAUNCHES_ITEMS_TYPE_STORAGE_KEY = "category-profile-launches-items-type";

export const LAUNCHES_GROUPING_TABS: { id: LaunchesGrouping; title: string }[] = [
    { id: "season", title: "Season" },
    { id: "month", title: "Month" },
];

export const LAUNCHES_SEASON_ORDER: YearSeasonsEnum[] = [
    YearSeasonsEnum.Winter,
    YearSeasonsEnum.Spring,
    YearSeasonsEnum.Summer,
    YearSeasonsEnum.Fall,
];

export const LAUNCHES_SEASON_LABELS: Record<YearSeasonsEnum, string> = {
    [YearSeasonsEnum.Winter]: "Winter",
    [YearSeasonsEnum.Spring]: "Spring",
    [YearSeasonsEnum.Summer]: "Summer",
    [YearSeasonsEnum.Fall]: "Fall",
    [YearSeasonsEnum.NotSet]: "",
};

export const LAUNCHES_FF_TOOLTIP = "count of menu launches containing that food / flavor";

export const buildLaunchesChainTooltip = (categoryName: string) =>
    `count of all new ${categoryName} menu items & LTO's at that chain`;
